/**
 * Trigger: tr_currencies_insert_fix_position
 * Purpose: Fix position conflicts when inserting a new currency
 * Table: currencies
 * Event: BEFORE INSERT
 */
export const TR_CURRENCIES_INSERT_FIX_POSITION = `
CREATE TRIGGER tr_currencies_insert_fix_position
BEFORE INSERT ON currencies
FOR EACH ROW
BEGIN
  UPDATE currencies
  SET position = (
      SELECT COALESCE(max(position), 0) + 1 FROM currencies
    ),
    updated_at = strftime('%s', 'now')
  WHERE new.position <> (
      SELECT COALESCE(max(position), 0) + 1 FROM currencies
    )
    AND new.position = position;
END;
`;
